let $1 = $(() => {
    const icon = e => {


      const $this = $(e.target);
      const caret = $this.prev(".nav-link");
      const caret_main = $this.prev(".btn-group").find(".caret");
      caret.toggleClass('active');
      caret_main.toggleClass('active');

      if($this.prev('a').length) {
        $('.icon').toggleClass('active')
      }
    }

    const overFlow = e => {
      e.preventDefault();
      $('body').toggleClass('overflow-hidden');
      const bars = $('.navbar-toggler').find('.bar')

      bars.toggleClass('animation')
    }

    $('.accordion')
        .on('hide.bs.collapse',icon)
        .on('show.bs.collapse',icon)

  $('.navbar-toggler').on('click',overFlow)


  $('input').attr("autocomplete","off")

  const sidebaActiveLink = $('.nav-link.active');

  if(sidebaActiveLink.length) {
    sidebaActiveLink.closest('.submenu-container').addClass('show')
      .prev('.btn-group').addClass('active')
      .find('.nav-link').attr('aria-expanded', 'true').toggleClass('active')
  }

});
